import {memo} from 'react'
import ButtonBase from '@mui/material/ButtonBase'
import {styled} from '@mui/material/styles'

import locales from '../../locales/index.json' 
import useLanguage from '../../hook/useLanguage'

import {
    TextM,
    Card,
    Dialog
} from '../../components'

const FLAG_ICON = {
    en: '🇺🇸',
    zh: '🇭🇰'
}

const ChangeLanguage = memo(({variant = 'text'}) => {
    const {
        lang,
        resources,
        checkoutLanguage
    } = useLanguage()
    // console.log({
    //     lang
    // })
    return (
        <Dialog
           switchElement={prop => (
                variant === 'flag' ?
                <FlagButton {...prop} aria-label='Change language'>
                    <FlagText>{FLAG_ICON[lang] || FLAG_ICON.zh}</FlagText>
                </FlagButton> :
                <TextM {...prop}>{locales.languageList[lang].name}</TextM>
           )} 
        >
            <Card spacing={[0.6]}>
                {
                    resources.map(v => (
                        <TextM
                            key={v}
                            style={{
                                padding:'6px 0px',
                                // marginLeft:'6px'
                                // width: '25%',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                            color={v === lang ? 1 : 2}
                            onClick={() => {
                                checkoutLanguage(v)
                            }}
                        >
                            <span>{FLAG_ICON[v] || FLAG_ICON.en}</span>
                            {locales.languageList[v].name}
                        </TextM>
                    ))
                }
            </Card>
        </Dialog>   
    )
})

export default ChangeLanguage

const FlagButton = styled(ButtonBase)`
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    border-radius: 50%;
    overflow: hidden;
    // background: linear-gradient(45deg, rgb(5 255 238), rgb(88 255 11), rgb(255 237 58));
    box-shadow: 0 0 0 1px rgb(0 0 0 / 28%), 0 4px 10px rgb(0 0 0 / 22%);
`

const FlagText = styled('span')`
    display: block;
    width: 28px;
    height: 28px;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
`
